import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { CleaningDialogComponent } from './cleaning-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export * from './cleaning-dialog.component';

@NgModule({
    declarations: [
        CleaningDialogComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule,
        MatProgressSpinnerModule,
    ],
    exports: [
        CleaningDialogComponent,
    ]
})
export class CleaningDialogModule { }
